import Home from "../../views/home";
import BasicViews from "../../views/basicViews";
import OperationsDashboard from "../../views/operationsDashboard";
import MonthlyCompliance from "../../views/monthlyCompliance";
import Audit from "../../views/audit"
import FloatAnalysis from "../../views/floatAnalysis"
import MonthlyExpiryList from "../../views/monthlyExpiryList";
import MonthlyAccountantsUpdate from "../../views/monthlyAccountantsUpdate";
import Charts from "../../views/charts";
import EstersPlayground from "../../views/EstersPlayground";
import MccLists from "../../views/mccLists";
import Live from "../../views/live";
import Subscriptions from "../../views/subscriptions";
import FraudMonitoring from "../../views/fraudMonitoring";
import AbroadPayments from "../../views/abroadPayments";
import IDT from "../../views/idt";
import RevenueViaFees from "../../views/revenueViaFees";
import FinancialCrime from "../../views/financialCrime";
import CardStatements from "../../views/cardStatements";
import Autotest from "../../views/autotest";
import Dashboard from "../../views/dashboard";
import Affiliates from "../../views/affiliates";

const Routes = () => {
    return [
      {
        path: "/",
        component: Home,
        label:"Home"
      },
      {
        path: "/live",
        component: Live,
        label:"Live"
      },
      {
        path: "/basicViews",
        component: BasicViews,
        label:"Basic Views"
      },
      {
        path: "/affiliates",
        component: Affiliates,
        label:"Affiliates"
      },
      {
        path: "/operationsDashboard",
        component: OperationsDashboard,
        label:"Operations Dashboard"
      },
      {
        path: "/cardStatements",
        component: CardStatements,
        label:"Card Statements"
      },
      {
        path: "/monthlyCompliance",
        component: MonthlyCompliance,
        label:"Monthly Compliance"
      },
      {
        path: "/audit",
        component: Audit,
        label:"Audit"
      },
      {
        path: "/floatAnalysis",
        component: FloatAnalysis,
        label:"Float Analysis"
      },
      {
        path: "/fraudMonitoring",
        component: FraudMonitoring,
        label:"Fraud Monitoring"
      },
      {
        path: "/monthlyExpiry",
        component: MonthlyExpiryList,
        label:"Monthly Expiry List"
      },
      {
        path: "/monthlyAccountantsUpdate",
        component: MonthlyAccountantsUpdate,
        label: "Monthly Acc. Update"
      },
      {
        path: "/esters",
        component: EstersPlayground,
        label: "Ester's Playground"
      },
      {
        path: "/mccLists",
        component: MccLists,
        label: "MCC Lists"
      },
      {
        path: "/subscriptions",
        component: Subscriptions,
        label: "Subscriptions"
      },
      {
        path: "/abroadPayments",
        component: AbroadPayments,
        label: "Abroad Payments"
      },
      {
        path: "/charts",
        component: Charts,
        label: "Test charts"
      },
      {
        path: "/idt",
        component: IDT,
        label: "IDT"
      },
      {
        path: "/revenue",
        component: RevenueViaFees,
        label: "Revenue Via Fees"
      },
      {
        path: "/financialCrime",
        component: FinancialCrime,
        label: "Financial Crime"
      },
      {
        path: "/autotest",
        component: Autotest,
        label: "Self Test"
      },
      {
        path: "/dashboard",
        component: Dashboard,
        label: "Dashboard"
      }

    ];
}

export default Routes